export default {
	getTripTypesWithInternalCode: (state) => state.tripTypes.filter(tripType => Object.keys(tripType).includes('internalCode'))
};